<script>
  import { ignore } from "../../Common/tools";
  import FilePicker from "../../Common/FilePicker.svelte";
  import LinkPicker from "../../Common/LinkPicker.svelte";
  import Checkbox from "../../Common/Checkbox.svelte";
  import { getCollapseClass } from "../../Common/tools";
  import Slider from "../../Common/Slider.svelte";
  import ColorPicker from "../../Common/ColorPicker.svelte";
  import {M} from "../../external";

  export let data,
    disable = [],
    customName = null,
    onChange = ignore,
    isCollapsable = false,
    isCollapsed = false,
    onCollapse = ignore;

  $: if (!data.hasLink) data.hasLink = false;

  function onFileSelected(base, file) {
    data = Object.assign({}, data, { base: base, file: file });
  }

  function onLinkSelected(value) {
    data = Object.assign({}, data, { link: value.link });
  }

  function toggleCollapse() {
    if (isCollapsable) {
      isCollapsed = !isCollapsed;
      onCollapse(isCollapsed);
    }
  }

  function onWidthChange(ev) {
    data.style = Object.assign({}, data.style, { width: ev + "%" });
  }
</script>

<div class="col20 f-left t-center mb-25 mt-15" on:click={toggleCollapse}>
  <h4 class="t-left {getCollapseClass(isCollapsable, isCollapsed)}">{customName ? customName : M.IMAGE}</h4>
</div>
{#if !isCollapsed}
  <FilePicker bind:file={data.file} config={{ placeholder: M.SELECT_IMAGE, imagesOnly: true }} onComplete={onFileSelected} />
  {#if disable.indexOf("link") === -1}
    {#if disable.indexOf("has-link") === -1}
      <Checkbox label={M.LINK_ENABLED} clz="popup-input-wrapper mt-5" bind:data={data.hasLink} />
    {/if}
    {#if data.hasLink}
      <div class="col20 f-left mt-15">
        <LinkPicker config={data} onComplete={onLinkSelected} emailLinkPicker={true} />
      </div>
    {/if}
  {/if}
  {#if disable.indexOf("width") === -1}
    <Slider min={1} max={100} value={data.style.width || 100} suffix="%" clz="mt-5" sameLine={true} onChange={onWidthChange} label={M.IMAGE_WIDTH} />

    <div class="col20 f-left color-pick-wrap-widgets">
      <ColorPicker bind:color={data.style.color} label={M.BACKGROUND_COLOR} alpha="no" />
    </div>
  {/if}
{/if}
